<template>
	<div class="header">
        <div class="top"></div>
		<ns-header-top />
		<ns-header-mid />
        <div id="nav-menu" class="nav-menu">
            <div v-if="isShow" style="position: absolute">
                <router-link to="/">
                    <el-image style="width: 100px;left: 40px;margin-top: 15px;" fit="cover" :src="$img('upload/1/common/images/20230207/20230207010844167574652442075.png')"></el-image>
                </router-link>
            </div>
            <div class="nav">
                <nav>
                    <ul class="menu_row" @mouseover="shopHover" @mouseleave="shopLeave">
                        <li class="menu" v-for="(item, index) in goodsCategoryTree" :class="[(select_category_class== item.category_id)?'li-act':'']" :key="index" @mouseover="selectedCategory = item.category_id" @mouseleave="selectedCategory = -1">
                            <router-link :to="{ path: '/list', query: { category_id: item.category_id, level: item.level } }">
                                <div>
                                    <img class="category-img"
                                         v-if="categoryConfig.img === 1 && item.image"
                                         :src="$util.img(item.image)" />
                                    <p class="category-name">{{ item.category_name }}</p>

                                </div>
                            </router-link>
                            <div class="cate-part" v-if="item.child_list" :class="{ show: selectedCategory == item.category_id }">
                                <div class="cate-part-col1">
                                    <div class="cate-detail">
                                        <div class="cate-detail-item" >
                                            <div class="cate-detail-con">
                                                <router-link
                                                    v-for="(second_item, second_index) in item.child_list" :key="second_index"
                                                    :to="{ path: '/list', query: { category_id: second_item.category_id, level: second_item.level } }"
                                                >
                                                    <img class="cate-detail-img"
                                                         v-if="categoryConfig.img == 1"
                                                         :src="$util.img(second_item.image)" />
                                                    <p class="category-name">{{second_item.category_name }}</p>
                                                </router-link>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </nav>
            </div>

            <div v-if="isShow" style="position: absolute;top:15px; right: 35px;">
                <span @click="$router.push('/cart')">
                    <el-badge :value="cartCount" class="item" type="warning">
                        <i class="el-icon-s-goods" style="font-size: 20px;"></i>
                    </el-badge>
                </span>
            </div>

        </div>
	</div>
</template>

<script>
import NsHeaderTop from './NsHeaderTop';
import NsHeaderMid from './NsHeaderMid';
import { tree , categoryConfig} from '@/api/goods/goodscategory';
import { navList } from '@/api/website';
import {
	mapGetters
} from "vuex"
export default {
	props: {
		forceExpand: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		...mapGetters(['is_show', 'cartCount'])
	},
	data() {
		return {
			isShopHover: false,
			isIndex: false,
			thisRoute: '',
			goodsCategoryTree: [],
			categoryConfig:{},
			selectedCategory: -1,
			navList: [],
			navSelect: '',
			isHide:false,
            select_category_class: 0,
            isShow: false
		};
	},
	components: {
		NsHeaderTop,
		NsHeaderMid,
		mapGetters
	},
	beforeCreate() {},
	created() {
        let mainParam = this.$route.query;
        if(mainParam.hasOwnProperty('category_id')){
            let the_id = parseInt(mainParam.category_id);
            this.select_category_class = the_id;
            this.goodsCategoryTree.forEach(item =>{
                if(the_id === item.category_id){
                    this.select_category_class = item.category_id;
                }else{
                    if(item.hasOwnProperty('child_list')){
                        item.child_list.forEach(child =>{
                            if(the_id === child.category_id){
                                this.select_category_class = item.category_id;
                            }
                        })
                    }
                }
            })
        }else{
            this.select_category_class = 0;
        }

        this.$store.dispatch('cart/cart_count');
		this.getCategoryConfig();
        this.getTree();

		if (this.$route.path == '/' || this.$route.path == '/index'){
			this.isIndex = true;
		}
	},
	watch: {
		$route: function(curr) {
            if(curr.query.hasOwnProperty('category_id')){
                let the_id = parseInt(curr.query.category_id);
                this.goodsCategoryTree.forEach(item =>{
                    if(the_id === item.category_id){
                        this.select_category_class = item.category_id;
                    }else{
                        if(item.hasOwnProperty('child_list')){
                            item.child_list.forEach(child =>{
                                if(the_id === child.category_id){
                                    this.select_category_class = item.category_id;
                                }
                            })
                        }
                    }
                })
            }else{
                this.select_category_class = 0;
            }

            this.initNav(curr.path);
			let judgeLength = localStorage.getItem('isAdList')
			if (this.$route.path == '/' || this.$route.path == '/index') this.isIndex = true;
			else this.isIndex = false;

			if (curr.path == '/list') {
				this.navSelect = '';
			}
		}
	},
    mounted() {
        window.addEventListener("scroll", this.handleScroll)
    },
    methods: {
        // 监听滚动条
        handleScroll() {
            var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
            if (scrollTop >= 75) {
                this.isShow = true
                let css = document.getElementById('nav-menu')
                css.style.position = 'fixed';
                css.style.zIndex = 99999;
                css.style.top = '3px';
            } else {
                this.isShow = false
                document.getElementById('nav-menu').style.position = 'relative';
            }
        },
        destroyed() {
            // 离开该页面需要移除这个监听的事件，不然会报错
            window.removeEventListener("scroll", this.handleScroll)
        },
		// 获取配置
		getCategoryConfig(){
			categoryConfig({
				
			})
			.then(res => {
				if (res.code == 0 && res.data) {
					this.categoryConfig = res.data;
					this.getTree(res.data);
				}
			})
			.catch(err => {
				this.$message.error(err.message);
			});
		},
		getTree(categoryConfig) {
			tree({
				level: 3,
				template: 2
			})
				.then(res => {
					if (res.code == 0 && res.data) {
                        //console.log('goodsCategoryTree=>',res.data)
                        this.goodsCategoryTree = res.data || [];
						for(let i =0;i<this.goodsCategoryTree.length;i++) {
							if(this.goodsCategoryTree[i].child_list > 3) {
								this.isHide = true
							}
						}
					}
				})
				.catch(err => {
					this.$message.error(err.message);
				});
		},
		nav() {
			navList({})
				.then(res => {
					if (res.code == 0 && res.data) {
                        //console.log('navList',res.data)
                        this.navList = res.data;
						for (let i in this.navList) {
							this.navList[i]['url'] = JSON.parse(this.navList[i]['nav_url']).url;
						}
						this.initNav(this.$route.path);
					}
				})
				.catch(err => {
					this.$message.error(err.message);
				});
		},
		navUrl(url, target) {
			if (!url) return;
			if (url.indexOf('http') == -1) {
				if (target) this.$router.pushToTab({ path: url });
				else this.$router.push({ path: url });
			} else {
				if (target) window.open(url);
				else window.location.href = url;
			}
		},
		initNav(path) {
			for (let i in this.navList) {
				if (this.navList[i]['url'] == path) {
					this.navSelect = path;
					continue;
				}
			}
		},
		
		//鼠标移入显示商品分类
		shopHover() {
			this.isShopHover = true;
		},
		//鼠标移出商品分类隐藏
		shopLeave() {
			this.isShopHover = false;
		}
	}
};
</script>

<style scoped lang="scss">
    .top{
        position: fixed;
        z-index: 999999;
        top: 0;
        width: 100%;
        border-top: 3px solid $base-color;
    }
.header {
	width: 100%;
	background-color: #fff;
	.shadow {
		box-shadow: -1px 3px 12px -1px rgba(0, 0, 0, 0.3);
	}
	.border {
		border: 1px solid #f5f5f5;
	}
    .nav-menu{
        background: white;
        width: 100%;
        z-index: 9999;
        border-bottom: 1px solid #f1f1f1;
        em{
            min-width: 17px;
            height: 15px;
            line-height: 15px;
            display: inline-block;
            padding: 0 2px;
            color: #ffffff;
            font-size: 10px;
            font-style: normal;
            text-align: center;
            border-radius: 8px;
            background-color: #b79962;
        }
    }
	.nav {
		height: 55px;
        width: 1000px;
		margin: 0 auto;
		position: relative;
		nav {
			width: 1000px;
			height: 55px;
            margin: 0 auto;
			font-size: 16px;
			ul {
				margin: 0;
				padding: 0;
				width: 100%;
				height: 100%;
				li.menu {
                    margin: 0 0.5%;
					cursor: pointer;
					list-style: none;
					float: left;
                    width: 9%;
                    text-align: center;
					height: 50px;
                    line-height: 50px;
                    font-weight: bold;
                    border-bottom: 3px solid #ffffff;
                    a {
						&:hover {
							color: #333333;
						}
					}
				}
				li.menu:hover {
					font-weight: bold;
                    border-bottom: 4px solid  #b79962;
                }
                .li-act{
                    font-weight: bold;
                    border-bottom: 4px solid  #b79962 !important;
                }
				.router-link-active {
					font-weight: bold;
				}
                .cate-part {
                    display: none;
                    position: absolute;
                    top: 55px;
                    left: 0;
                    z-index: 10;
                    width: 998px;
                    min-height: 150px;
                    overflow-y: auto;
                    border: 1px solid #f7f7f7;
                    background-color: #fff;
                    -webkit-box-shadow: 2px 0 5px rgba(0, 0, 0, 0.05);
                    -moz-box-shadow: 2px 0 5px rgba(0, 0, 0, 0.05);
                    box-shadow: 2px 0 5px rgba(0, 0, 0, 0.05);
                    -webkit-transition: top 0.25s ease;
                    -o-transition: top 0.25s ease;
                    -moz-transition: top 0.25s ease;
                    transition: top 0.25s ease;
                    &.show {
                        display: block;
                    }
                    &::-webkit-scrollbar{
                        display: none;
                    }
                }
                .cate-part-col1 {
                    float: left;
                    width: 100%;
                    .cate-detail-item {
                        position: relative;
                        min-height: 36px;
                        padding-left: 20px;
                        &:last-child{
                            margin-bottom: 30px;
                        }
                        .cate-detail-tit {
                            margin-top:30px;
                            margin-right: 20px;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                            font-weight: 700;
                            a {
                                display: block;
                                color: #333333;
                            }
                            a:hover{
                                color: $base-color;
                            }

                        }
                        .cate-detail-con {
                            overflow: hidden;
                            padding: 6px 0 6px 17px;
                            display: flex;
                            flex-wrap: wrap;
                            // border-top: 1px dashed #eee;
                            a {
                                justify-content: start;
                                font-size: 14px;
                                height:30px;
                                /* float: left; */
                                margin: 4px 40px 4px 0;
                                padding: 0 10px;
                                white-space: nowrap;
                                line-height: 30px;
                                color: #555555;
                                width: calc((100% - 120px) / 4);
                                display: flex;
                                box-sizing: border-box;
                                margin-top: 20px;
                                .cate-detail-img{
                                    width:30px;
                                    height: 30px;
                                    margin-right: 10px;
                                }
                                &:nth-child(4n+4){
                                    margin-right: 0;
                                }
                            }
                            a:hover{
                                color: $base-color;
                            }
                        }
                        &:first-child .cate-detail-con {
                            border-top: none;
                        }
                    }
                }

            }
		}
	}
}
</style>
